<template>
    <div class="layout-footer" :class="{ 'desktop-layout-footer': isDesktop, 'mobile-layout-footer': !isDesktop }">
       <div class="container-wrapper-footer-left">
            <ul class="container-wrapper-list">
                <li>
                    <el-image :src="logo" loading="lazy" class="logo-img"/>
                </li>
                <li class="point">
                </li>
                <li class="business-text">
                    {{ t('header_business') }}
                </li>
            </ul>

            <!-- <ul class="common-list product-list">
                <li>{{ t('header_bottom_title1') }}</li>
                <li class="cursor">
                    <nuxt-link :to="localePath('/translate')">
                        {{ t('header_bottom_title1_child1') }}
                    </nuxt-link>
                </li>
                <li class="cursor">
                    <nuxt-link :to="localePath('/home')">
                        {{ t('header_bottom_title1_child2') }}
                    </nuxt-link>
                </li>
            </ul>

            <ul class="common-list">
                <li>{{ t('header_bottom_title2') }}</li>
                <li class="cursor">
                    <nuxt-link :to="localePath('/pro')">
                        {{ t('header_bottom_title2_child1') }}
                    </nuxt-link>
                </li>
                <li class="cursor">
                    <nuxt-link :to="localePath('/download')">
                        {{ t('header_bottom_title2_child2') }}
                    </nuxt-link>
                </li>
            </ul>

            <ul class="common-list">
                <li>{{ t('header_bottom_title3') }}</li>
                <li class="cursor">
                    <nuxt-link :to="appDomains.helpCenterUrl" target="_blank">
                        {{ t('header_bottom_title3_child1') }}
                    </nuxt-link>
                </li>
                <li class="cursor">
                    <nuxt-link :to="localePath('/account/agreement/userAgreement')">
                        {{ t('header_bottom_title3_child2') }}
                    </nuxt-link>
                </li>
                <li class="cursor">
                    <nuxt-link :to="localePath('/account/agreement/userPrivacy')">
                        {{ t('header_bottom_title3_child3') }}
                    </nuxt-link>
                </li>
                <li class="cursor">
                    <nuxt-link :to="localePath('/versionRecord')" target="_blank">
                        {{ t('header_bottom_title3_child4') }}
                    </nuxt-link>
                </li>
                <li class="cursor">
                    <nuxt-link :to="localePath('/introduction')">
                        {{ t('header_bottom_title3_child5') }}
                    </nuxt-link>
                </li>
                <li class="cursor" >
                    <nuxt-link :to="localePath('/blog')" target="_blank"> 
                        {{ t('header_bottom_title3_child7') }}
                    </nuxt-link>
                </li>
            </ul>

            <ul class="common-list">
                <li>{{ t('header_bottom_title4') }}</li>
                <li>{{ t('header_bottom_title4_child1').replace("*", contactEmail) }}</li>
                <li class="iconfontBox-list">
                    <div v-for="(item, index) in supportImageList" class="iconfontBox" :key="item.iconfont"
                        :class="item.iconfont + '-box'"
                        @click="handleSupportClick(item.iconfont)"
                    >
                        <i class="iconfont" :class="item.iconfont"/>
                    </div>
                </li>
            </ul> -->
       </div>
       <div class="container-wrapper-footer">
            <ul class="container-wrapper-list info-list">
                <li v-if="!isVipSite && systemLanguage?.code === SystemLanguageEnum.JA">
                        特定商取引法に基づく表記
                </li>
                <li v-if="isVipSite">
                        鄂ICP备2024074342号-1
                </li>
                <li class="contact-item">{{ t('header_bottom_title4_child1').replace("*", contactEmail) }}</li>
            </ul>
            <ul class="container-wrapper-list copyright-list">
                <li>  Copyright © 2026 Doclingo. All Rights Reserved. </li>
            </ul>
       </div>
    </div>
</template>

<script setup lang="ts">
import useSystemLaunageStore from '~/store/modules/systemLaunage'
import { SystemLanguageEnum } from '~/types/const'
import { useSiteConfig } from '~/config/useSiteConfig'
const viewport = useViewport()
const isDesktop = computed(() => viewport.breakpoint?.value.includes('desktop'))
const logo = new URL('@/assets/images/icon_logo.png', import.meta.url).href
const systemLanguageStore = useSystemLaunageStore()
const { systemLanguage } = storeToRefs(systemLanguageStore)
const { t } = useI18n()
const localePath = useLocalePath()
const appDomains = useAppDomainConfig()
const { isVipSite } = useSiteConfig()
const contactEmail = appDomains.contactEmail
const supportImageList = computed(() => {
    if(isVipSite.value){
        return [
           { iconfont: "icon-icon_xiaohongshu"},
           { iconfont: "icon-icon_bilibili"},
           { iconfont: "icon-icon_email"}    
        ]
    }else{
        return [
            { iconfont: "icon-icon_xiaohongshu"},
            { iconfont: "icon-icon_bilibili"},
            { iconfont: "icon-icon_twitter1"},
            { iconfont: "icon-icon_youtobe"},
            { iconfont: "icon-icon_email"}
        ]
    }
})

function handleSupportClick(iconfont: string) {
    switch(iconfont){
        case "icon-icon_xiaohongshu":
            window.open("https://reurl.cc/ZVL046", "_blank")
            break
        case "icon-icon_bilibili":
            window.location.href = "https://b23.tv/ZtMeRDh"
            break
        case "icon-icon_twitter1":
            window.open("http://twitter.com/doclingopdf", "_blank")
            break
        case "icon-icon_youtobe":
            window.location.href = "https://www.youtube.com/@DoclingoTranslation/videos"
            break
        case "icon-icon_email":
            window.location.href = `mailto:${contactEmail.value}`
            break
        default:
            break
    }
}
</script>

<style scoped lang="scss">
@use "./index.scss" as *;
</style>
